import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { ViewTemplate } from '../../models/template.model';

@Injectable({ providedIn: 'root' })
export class SelectedTemplateService {
  #template = new BehaviorSubject<ViewTemplate>(null);
  selectedViewTemplateChange$ = this.#template.asObservable();

  setSelectedViewTemplate(template: ViewTemplate): void {
    this.#template.next(template);
  }

  getSelectedViewTemplate(): ViewTemplate {
    return this.#template.value;
  }
}
